import { Module } from 'vuex';
import { cloneDeep } from 'lodash';
import { Store } from '@/store/types';
import { AuthenticationState } from '../types';
import { authenticationGetters } from './getters';
import { authenticationActions } from './actions';
import { authenticationMutations } from './mutations';
import { authenticationStateDefaults } from './defaults';

export const authenticationState: Module<AuthenticationState, Store> = {
  namespaced: true,
  state: cloneDeep(authenticationStateDefaults),
  getters: authenticationGetters,
  actions: authenticationActions,
  mutations: authenticationMutations
};
